// Interpreting the eSIM lifecycle state the API reports.
//
// The server's EsimStateEnum carries fifteen values. The customer profile used to string-match
// exactly two of them - "installed" and "released" - so an eSIM in any other state failed to
// match at all. ENABLED is the profile switched on and in use, and it fell through, which took
// the customer's whole plan off the page with it. Classify explicitly instead, and treat an
// unrecognised value as unusable rather than as anything actionable, so a new enum value
// degrades quietly instead of hiding a plan.

export type EsimInstallState = "installed" | "awaitingInstall" | "unavailable";

// On a device. DISABLED belongs here: the profile is installed, just switched off.
const INSTALLED_STATES = ["installed", "downloaded", "enabled", "disabled"];

// Issued or being prepared, still to be installed. RELEASED is the one an installation link is
// normally issued for; the rest are earlier steps towards it.
const AWAITING_INSTALL_STATES = ["released", "confirmed", "linked", "allocated", "created", "available"];

export function esimInstallState(state: string | undefined | null): EsimInstallState {
    const normalised = (state ?? "").trim().toLowerCase();
    if (INSTALLED_STATES.includes(normalised)) return "installed";
    if (AWAITING_INSTALL_STATES.includes(normalised)) return "awaitingInstall";
    // ERROR, UNAVAILABLE, DELETED, UNKNOWN, QUARANTINE - and anything added later.
    return "unavailable";
}

export function isEsimInstalled(state: string | undefined | null): boolean {
    return esimInstallState(state) === "installed";
}

export function isEsimAwaitingInstall(state: string | undefined | null): boolean {
    return esimInstallState(state) === "awaitingInstall";
}
